import { Images } from '../../typings'

export enum IImgColor {
  COLOR,
  GREY,
}

export interface IBankLogo {
  logoSrc: {
    [IImgColor.COLOR]: string
    [IImgColor.GREY]: string
  }
  logoColor?: IImgColor
  customSizing?: {
    height: number | string
    width: number | string
  }
}

export interface IBankLogoContainer {
  imageSources: Images
  recommendationRate: number
  isRowExpanded: boolean
}
